import api from '@/lib/api'
import { getHeaderToken } from '@/utils/getHeaderToken'

import { API_S3_BUCKET } from '../apiRoutes'
interface Body {
  bucket_name: string
  bucket_quota: number
}
interface Response {
  [x: string]: any
  amount: number
  name: string
  bucket: string
  token: string
}

export const postBucket = async (
  { bucket_name, bucket_quota }: Body,
  token: string
) => {
  try {
    const { data } = await api.post<Response>(
      API_S3_BUCKET,
      { bucket_name, bucket_quota },
      {
        headers: getHeaderToken(token),
      }
    )
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
